import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import LoadingPage from '../LoadingPage';
import ModalList from './ModalList';
import Api from '../../services/ApiService';
import ModalContext from './ModalContext';

const ModalListContainer = props => {
  const { view, lookupKey, branchId, title } = props;
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const { setTitle } = useContext(ModalContext);

  const getData = () => {
    setLoading(true);

    const query = branchId !== undefined ? `?branchId=${branchId}` : '';

    Api.get(`drilldown/${view}/${encodeURIComponent(lookupKey)}${query}`).then(response => {
      const { data } = response.data;

      let formattedData = {};
      if (Array.isArray(data)) {
        data.forEach(listItem => {
          formattedData[listItem[0]] = listItem[1];
        });
      } else {
        formattedData = data;
      }

      setLoading(false);
      setData(formattedData);
      setTitle(`${title} (${lookupKey})`);
    });
  };

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="modal-list-container">
      <ModalList data={data} />
    </div>
  );
};

ModalListContainer.defaultProps = {};

ModalListContainer.propTypes = {
  branchId: PropTypes.string,
  lookupKey: PropTypes.string,
  title: PropTypes.string,
  view: PropTypes.string,
};

export default ModalListContainer;
